module.exports = __webpack_public_path__ + "img/icon-canceled.dfc84299.svg";